//精度计算；
import Decimal from 'decimal.js';
// 设置全局默认精度为 20 位有效数字
Decimal.set({ precision: 20 });


//加法；num1 + num2;
function add(num1=0, num2=0){
	const a = new Decimal(num1);
	const b = new Decimal(num2);
	return a.plus(b).toString();
}


//减法；num1 - num2;
function sub(num1=0, num2=0){
	const a = new Decimal(num1);
	const b = new Decimal(num2);
	return a.minus(b).toString();
}


//乘法；num1 * num2;
function mul(num1=0, num2=0){
	const a = new Decimal(num1);
	const b = new Decimal(num2);
	return a.times(b).toString();
}


//除法；num1 / num2;
function div(num1=0, num2=0){
	const a = new Decimal(num1);
	const b = new Decimal(num2);
	return a.div(b).toString();
}


/**
 * 保留小数
 * dec: 保留小数位，默认2为小数；
 * type: 0-截断，1-向下舍入，2-向上舍入，3-四舍五入，4-四舍六入；
 */
function Places(num=0, dec=2, type=3){
	const a = new Decimal(num);
	return a.toDecimalPlaces(dec, type).toString();
}


export default {
	add, 
	sub, 
	mul, 
	div, 
	Places
}